<template>
  <div class="ras-feelings ras-page">
    <div class="ras-page__back">
      <button @click="$router.go(-1)"><SVGArrowLeft /> Back</button>
    </div>
    <div class="ras-page__header">
      <h1 class="ras-page__question">How do you want to feel when watching?</h1>
      <p class="ras-page__info">Select 2 categories</p>
    </div>
    <form class="ras-page__form" @submit.prevent="nextStep">
      <div class="checkbox-wrapper">
        <CheckboxButton @can-progress="checkFormValid" :selected="checked" :min="2" :max="2" :icons="true" :options="getFeelings" v-model="form.feelings"></CheckboxButton>
      </div>
      <div class="button-wrapper">
        <button :class="['ras-button', {'ras-button--disabled': !formValid}]">Next Step</button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CheckboxButton from '@/components/CheckboxButton'
import SVGArrowLeft from '@/assets/svgs/arrow-left.svg?inline'
export default {
  components: {
    CheckboxButton,
    SVGArrowLeft
  },
  computed: {
    ...mapGetters(['getFeelings'])
  },
  data: () => ({
    form: {
      feelings: []
    },
    checked: [],
    formValid: false,
  }),
  methods: {
    nextStep() {
      if(this.formValid) {
        this.$store.dispatch('setFormData', this.form).then(() => {
          this.$router.push({ path: 'vacation' })
        })
      }
    },
    checkFormValid(event) {
      this.formValid = event
    }
  },
  mounted() {
      if(this.$store.getters.getFormByKey('feelings').length) {
        this.checked = this.$store.getters.getFormByKey('feelings')
        this.form.feelings = this.$store.getters.getFormByKey('feelings')
      }
      else {
        this.form.feelings = []
      }
  }
}
</script>

<style>

</style>